import R from 'app/assets/R'
import {
  UnlockOutlined,
  LockOutlined,
} from '@ant-design/icons'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { useTranslation } from 'react-i18next'
import { BaseButton } from 'app/components/common/BaseButton'
import BaseText from 'app/components/common/BaseText'
import dayjs, { Dayjs } from 'dayjs'
import { isNil } from 'lodash'

export interface ISyncLock {
  value: string
  label: string
  isLocked: boolean
  isLoading?: boolean
}

const SyncLockListItem: React.FC<{
  syncLocks: ISyncLock[]
  handleUpsertSyncLocks: (date: Dayjs, isLocked: boolean) => Promise<void>
}> = ({ syncLocks, handleUpsertSyncLocks }) => {
  const { t } = useTranslation()

  return (
    <BaseRow gutter={6} style={{ maxHeight: 300, overflowY: 'auto' }}>
      {syncLocks.map((syncLock: ISyncLock) => {
        const isLocked = isNil(syncLock?.isLocked) || syncLock?.isLocked

        return (
          <BaseCol span={24} key={syncLock?.value} style={{ marginBottom: 8 }}>
            <BaseRow gutter={6} justify={'space-between'} align={'middle'}>
              <BaseCol>
                <BaseRow gutter={6} align={'middle'} justify={'start'}>
                  <BaseCol>
                    {isLocked && <LockOutlined rev={undefined} />}
                    {!isLocked && <UnlockOutlined rev={undefined} />}
                  </BaseCol>
                  <BaseText
                    fontSize={'xs'}
                    children={`${t(R.strings.month)} ${syncLock?.label}`}
                  />
                </BaseRow>
              </BaseCol>
              <BaseCol>
                <BaseButton
                  children={
                    <BaseRow gutter={6} align={'middle'} justify={'start'}>
                      <BaseCol>
                        {isLocked && (
                          <BaseText children={t(R.strings.unlock)} />
                        )}
                        {!isLocked && <BaseText children={t(R.strings.lock)} />}
                      </BaseCol>
                    </BaseRow>
                  }
                  onClick={() =>
                    handleUpsertSyncLocks(dayjs(syncLock?.value), !isLocked)
                  }
                  loading={syncLock?.isLoading}
                  disabled={syncLock?.isLoading}
                />
              </BaseCol>
            </BaseRow>
          </BaseCol>
        )
      })}
    </BaseRow>
  )
}

export default SyncLockListItem
